import { useState } from "react";
import { Hourglass } from "lucide-react";
import { mediaUrl } from "../lib/api";

/**
 * Image that NEVER shows a broken-file icon. Resolves uploaded/relative paths via
 * mediaUrl and, on load error, renders `fallback` (or nothing) instead.
 */
export function SmartImage({ src, alt = "", className = "", fallback = null, ...rest }) {
  const [failed, setFailed] = useState(false);
  const resolved = mediaUrl(src);
  if (!resolved || failed) return fallback;
  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}

/** Avatar with graceful initials fallback (no broken images, ever). */
export function Avatar({ src, name = "?", className = "object-cover", textClass = "text-gold" }) {
  const initial = (name || "?")[0]?.toUpperCase();
  return (
    <SmartImage
      src={src}
      alt={name}
      className={`w-full h-full ${className}`}
      fallback={
        <div className={`w-full h-full flex items-center justify-center font-display ${textClass}`}>{initial}</div>
      }
    />
  );
}

/** Centered loading shimmer for panels/tabs (used instead of rendering null). */
export function PanelLoading({ label = "Loading" }) {
  return (
    <div className="py-20 flex flex-col items-center justify-center gap-3 text-textDim" data-testid="panel-loading">
      <Hourglass className="w-6 h-6 text-gold animate-glow" />
      <div className="overline">{label}…</div>
    </div>
  );
}
